import React, { useEffect, useState } from 'react';
import {
  Col,
  Modal,
  Row,
  Button,
  Tabs,
  Divider,
  Switch,
  Select,
  Form,
  Card,
} from 'antd';
import { FormInstance } from 'antd/lib/form';
import { CloseOutlined, CheckOutlined } from '@ant-design/icons';
import * as finEngine from 'services/finEngine';
import IUpdate from 'icons/IUpdate';
import IAdd from 'icons/IAdd';
import _ from 'lodash';
import GetLabel from 'DisplayFramework/components/GetLabel';
import { dateToString } from 'utils/utils2';
import InputCurrency from 'components/InputCurrency';
import ParListSelectWithLabelInValue from 'components/ParListSelectWithLabelInValue';
import { offerToElement } from 'pages/ProposalV3/PropDetail/offerToElement';
import PricingInput from './PricingInput';
import TextArea from 'antd/lib/input/TextArea';
import FormInput from 'components/FormInput';
import {
  AssetUseCriteria,
  FilteringCriteria,
  prFilteringCriteria,
} from 'services/pricing';
import { getRounding, toCurrency } from 'utils/utils';
import { PropElementResponse } from 'services/proposal';
import getEnvValue from 'utils/getEnvValue';
import InputRate from 'components/InputRate';
import Value from 'components/Value';
import ParListSelect from 'components/ParListSelect';
import ParCalendarSelect from 'pages/Configuration/ParCalendar/ParCalendarSelect';

const { TabPane } = Tabs;

export type SimpleFinElementModalProps = {
  updateElement?: boolean;
  finElement?: any;
  visible?: boolean;
  display?: boolean;
  onSave: (serv: any, allElements: any, action: string) => void;
  onClose?: any;
  form?: FormInstance;
  offerParams: any;
  ctfclevel?: string;
  assetAmount?: number;
  totalFinAmountElemLinkedToAsset?: number;
  elements?: any[];
};

const SimpleFinElementModal = (props: SimpleFinElementModalProps) => {
  const {
    onSave,
    visible = false,
    onClose,
    display,
    finElement,
    updateElement = false,
    form,
    offerParams,
    ctfclevel,
    assetAmount = 0,
    totalFinAmountElemLinkedToAsset = 0,
    elements,
  } = props;

  const [maxInvestAmount, setMaxInvestAmount] = useState(0);

  const [ctecategory, setCtecategory] = useState<string>('');

  const calculateSubsidy = (e: any) => {
    const element = form
      ?.getFieldValue(['elements', 'FIN'])
      .filter((elem: any) => elem.cteid === e)[0];

    const totalInterest = _.sumBy(
      finElement?.conElemSchedules,
      'ctsinterestamount'
    );

    switch (element?.ctecalculationtype) {
      case 'SEASON':
        calculateSeasonalInterest(element, finElement, totalInterest);
        //OK
        break;
      case 'LINEAR':
        calculateLinearAndWeightedInterest(finElement, element, totalInterest);

        //OK
        break;
    } // end switch calctype
  };

  const calculateLinearAndWeightedInterest = (
    newElement: PropElementResponse,
    finElementtoCopy: PropElementResponse,
    totalInterest: number
  ) => {
    let firstPayment =
      (finElementtoCopy.ctefirstpaymentcoef * newElement.cteinvestamount) / 100;
    let rvAmount =
      (finElementtoCopy.ctervcoef * newElement.cteinvestamount) / 100;

    finEngine
      .calculate({
        finReq: {
          inBillingDate: finElementtoCopy?.ctebilligdate,
          inCalculationMethod: 'INST',
          inCalculationType:finElementtoCopy?.ctecalculationtype,
          inCountingbasis: finElementtoCopy?.cteratebasis,
          inDeferredMethod: finElementtoCopy?.ctedeferredinterestmethod,
          inDeferredRate: finElementtoCopy?.ctedeferredinterestnominalrate,
          inDepositAmount:
            finElementtoCopy?.ctedepositamount == null
              ? 0
              : finElementtoCopy?.ctedepositamount,
          inDepositMethod: finElementtoCopy?.ctedepositinterestmethod,
          inDepositRate:
            finElementtoCopy?.ctedepositinterestmethod === 'NONE'
              ? 0
              : finElementtoCopy?.ctedepositnominalrate == null
              ? 0
              : finElementtoCopy?.ctedepositnominalrate,
          inDuration: finElementtoCopy?.cteduration,
          inFinancedAmount: newElement.ctefinancedamount,
          inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
          inFirstPayment: firstPayment,
          inGracePeriodDuration:
            finElementtoCopy?.ctegraceperiodduration == null
              ? 0
              : finElementtoCopy?.ctegraceperiodduration,
          inGracePeriodMethod: finElementtoCopy?.ctegraceperiodmethod,
          inInstallmentAmount: finElementtoCopy?.cteinstallmentamount,
          inInterestMethod: finElementtoCopy?.cteinterestmethod,
          inPartAmount:
            finElementtoCopy?.ctepartamount == null
              ? 0
              : finElementtoCopy?.ctepartamount,
          inPartMethod: finElementtoCopy?.ctepartmethod
            ? finElementtoCopy?.ctepartmethod
            : 'NONE',
          inPartNbDays:
            finElementtoCopy?.ctepartdays == null
              ? 0
              : finElementtoCopy?.ctepartdays,
          inPartRate:
            finElementtoCopy?.ctepartrate == null
              ? 0
              : finElementtoCopy?.ctepartrate,
          inPeriodicity: finElementtoCopy?.cteperiodicity,
          inPeriodicityUnit: finElementtoCopy?.cteunit,
          inRatePeriodicity: Number(finElementtoCopy?.cterateperiodicity),
          inRateType: finElementtoCopy?.cteratetype,
          inRateValue:
            finElementtoCopy?.ctenominalrate == null
              ? 0
              : finElementtoCopy?.ctenominalrate,
          inResidualValue: rvAmount == null ? 0 : rvAmount,
          inRoundingAmount: getRounding(finElementtoCopy.currcode),
          inRoundingRate: 9,
          inStartDate: dateToString(finElementtoCopy?.ctestartdate),
          inTaxcode: finElementtoCopy?.taxcode,
          inTaxrate: finElementtoCopy?.taxrate,
          inTaxtype: 'RENTAL', // @todo change it when it is changed on the server
          inTerm: finElementtoCopy?.ctepaymentterm,
          inUpFrontAmount:
            finElementtoCopy?.cteupfrontamount == null
              ? 0
              : finElementtoCopy?.cteupfrontamount,
        },
      })
      .then((res) => {
        if (res.success) {
          // calculate RVI :

          const newInterest = _.sumBy(res.paymentSchedule, 'ctsinterestamount');

          form?.setFieldsValue({
            oldinterest: totalInterest,
            newinterest: newInterest,
            subsidy: totalInterest - newInterest,
            pricing2: {
              priid: finElementtoCopy?.priid ?? null,
              prilabel: finElementtoCopy?.prilabel ?? null,
              ofrid: finElementtoCopy?.ofrid ?? null,
              ofrlabel: finElementtoCopy?.ofrlabel ?? null,
              ofrtype: finElementtoCopy?.ofrtype ?? null,
            },
          });
        } else {
        }
      }); // end then
  };

  const calculateSeasonalInterest = (
    newElement: PropElementResponse,
    finElementtoCopy: PropElementResponse,
    totalInterest: number
  ) => {
    const FinElemStep = finElementtoCopy.conElemSteps;

    // calculate FIN

    var finamount = 0;
    const investamount = newElement.cteinvestamount;
    const upfront = newElement.cteupfrontamount;

    var part = 0;

    const partmethod = finElementtoCopy.ctepartmethod;

    if (partmethod === 'PROMO' || partmethod === 'REDUCEFIN') {
      part = isNaN(finElementtoCopy.ctepartamount)
        ? 0
        : finElementtoCopy.ctepartamount;
    }

    finamount = investamount - upfront - part;

    finEngine
      .calculateSeasonalSchedule({
        finReq: {
          elementStep: FinElemStep,
          inBillingDate: finElementtoCopy?.ctebilligdate,
          inCalculationMethod: 'SEASON',
          inCountingbasis: finElementtoCopy?.cteratebasis,
          inDeferredMethod: finElementtoCopy?.ctedeferredinterestmethod,
          inDeferredRate: finElementtoCopy?.ctedeferredinterestnominalrate,
          inDepositAmount:
            finElementtoCopy?.ctedepositamount == null
              ? 0
              : finElementtoCopy?.ctedepositamount,
          inDepositMethod: finElementtoCopy?.ctedepositinterestmethod,
          inDepositRate:
            finElementtoCopy?.ctedepositnominalrate == null
              ? 0
              : finElementtoCopy?.ctedepositnominalrate,

          inFinancedAmount: finamount,
          inFirstInstallmentDate: '', //dateToString(finElement?.ctestartdate),
          inInterestMethod: finElementtoCopy?.cteinterestmethod,
          inPartAmount:
            finElementtoCopy?.ctepartamount == null
              ? 0
              : finElementtoCopy?.ctepartamount,
          inPartMethod: finElementtoCopy?.ctepartmethod
            ? finElementtoCopy?.ctepartmethod
            : 'NONE',
          inPartNbDays:
            finElementtoCopy?.ctepartdays == null
              ? 0
              : finElementtoCopy?.ctepartdays,
          inPartRate:
            finElementtoCopy?.ctepartrate == null ? 0 : finElement?.ctepartrate,
          inRatePeriodicity: Number(finElementtoCopy?.cterateperiodicity),
          inRateType: finElementtoCopy?.cteratetype,
          inRateValue:
            finElementtoCopy?.ctenominalrate == null
              ? 0
              : finElementtoCopy?.ctenominalrate,
          inRoundingAmount: getRounding(finElementtoCopy.currcode),
          inRoundingRate: 9,
          inStartDate: dateToString(finElementtoCopy.ctestartdate),
          inTaxcode: finElementtoCopy?.taxcode,
          inTaxrate: finElementtoCopy?.taxrate,
          inTaxtype: 'RENTAL', // @todo change it when it is changed on the server
          inTerm: finElementtoCopy?.ctepaymentterm,
          inDuration: finElementtoCopy?.cteduration,
          inFirstPayment: finElementtoCopy?.ctefirstpayment,
          inResidualValue:
            finElementtoCopy?.ctervamount === null
              ? 0
              : finElementtoCopy?.ctervamount,
          inUpFrontAmount:
            finElementtoCopy?.cteupfrontamount === null
              ? 0
              : finElementtoCopy?.cteupfrontamount,
        },
      })
      .then((res) => {
        if (res.success) {
          // calculate RVI :

          const newInterest = _.sumBy(res.paymentSchedule, 'ctsinterestamount');

          form?.setFieldsValue({
            oldinterest: totalInterest,
            newinterest: newInterest,
            subsidy: totalInterest - newInterest,
            pricing2: {
              priid: finElementtoCopy?.priid ?? null,
              prilabel: finElementtoCopy?.prilabel ?? null,
              ofrid: finElementtoCopy?.ofrid ?? null,
              ofrlabel: finElementtoCopy?.ofrlabel ?? null,
              ofrtype: finElementtoCopy?.ofrtype ?? null,
            },
          });
        }
      });

    /// end calculate FIN
  }; //end calculation of PaymentShedule Seasonal :

  useEffect(() => {
    if (form && updateElement) {

      if (ctfclevel === 'MOASSMUEL') {
        let max = assetAmount - totalFinAmountElemLinkedToAsset;
        setMaxInvestAmount(max >= 0 ? max : 0);
      }

      const percentAmountAsset =
        ctfclevel === 'MOASSMUEL'
          ? (finElement?.ctefinancedamount / assetAmount) * 100
          : 0;

      form.setFieldsValue({
        ctedescription: finElement?.ctedescription ?? '',
        cteinvestamount: finElement?.ctefinancedamount,
        ctevatdeferralamount: finElement?.ctevatdeferralamount,
        pricing: finElement?.ofrid === 0 ? null : finElement?.ofrid,
        ctecategory: {
          value: finElement?.ctecategory,
          label: finElement?.ctecategorylabel,
        },
        percentAmountAsset: percentAmountAsset >= 0 ? percentAmountAsset : 0,
        assetamount: assetAmount,
        calid: finElement?.calid ?? form.getFieldValue('calid'),
        ctedirection:finElement.ctedirection
      });
      setCtecategory(finElement?.ctecategory);
    } else {
      form?.setFieldsValue({
        ctedescription: null,
        cteinvestamount: 0,
        ctevatdeferralamount: 0,
        pricing: null,
        ctecategory: null,
      });
      if (ctfclevel === 'MOASSMUEL') {
        let max = assetAmount - totalFinAmountElemLinkedToAsset;
        setMaxInvestAmount(max >= 0 ? max : 0);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    form,
    visible,
    updateElement,
    assetAmount,
    totalFinAmountElemLinkedToAsset,
  ]);


  const addElement = () => {
    const cteid = Math.round(_.random(10000) * 10000000);

    const newElement = offerToElement(
      offerParams,
      form?.getFieldValue('cteinvestamount'),
      form?.getFieldValue('ctevatdeferralamount'),
      0,
      false,
      'NONE',
      0,
      cteid
    );

    const catlabel = form?.getFieldValue('ctecategory')?.label ?? 'Financial';
    const catvalue = form?.getFieldValue('ctecategory')?.value ?? 'FIN';

    let ofrid = form?.getFieldValue('pricing')?.ofrid ?? null;
    let ofrlabel = form?.getFieldValue('pricing')?.ofrlabel ?? null;
    let ofrtype = form?.getFieldValue('pricing')?.ofrtype ?? null;

    const updatedobject = {
      ...newElement,
      ofrid: ofrid,
      ofrlabel: ofrlabel,
      ofrtype: ofrtype,
      cteinvestamount: form?.getFieldValue('cteinvestamount'),
      ctecategory: catvalue,
      ctecategorylabel: catlabel,
      ctedescription: form?.getFieldValue('ctedescription') ?? '',
      calid: form?.getFieldValue('calid'),
      ctedirection:form?.getFieldValue('ctedirection')
    };

    return updatedobject;
  };

  const getFilterList = (): prFilteringCriteria => {
    let assetList = form
      ?.getFieldValue('assets')
      ?.filter((a: any) => a.cteid === finElement?.cteid);

    let assetUseCriteriaList: Array<AssetUseCriteria> = [];
    let offerCriteriaList: Array<FilteringCriteria> = [];
    let ret: prFilteringCriteria;

    offerCriteriaList.push({
      critcode: 'TPTYPE',
      critvalue: form?.getFieldValue('client')?.tptype ?? '',
    });
    offerCriteriaList.push({
      critcode: 'OFFER',
      critvalue: form?.getFieldValue('offerid') ?? '0',
    });
    offerCriteriaList.push({
      critcode: 'PRCODE',
      critvalue: form?.getFieldValue('flagmasterfacility')
        ? form?.getFieldValue('mfprcode')
        : form?.getFieldValue('prcode') ?? '',
    });
    offerCriteriaList.push({
      critcode: 'NETWORK',
      critvalue: form?.getFieldValue('ctnetworkcode') ?? '',
    });
    offerCriteriaList.push({
      critcode: 'CLIRATING',
      critvalue: form?.getFieldValue('client')?.tpsalestatus ?? '',
    });

    assetList?.forEach((a: any) => {
      offerCriteriaList.push({
        critcode: 'ASSETFAM',
        critvalue: a.assetfamily,
      });
      offerCriteriaList.push({ critcode: 'ASSETTYPE', critvalue: a.assettype });

      offerCriteriaList.push({
        critcode: 'ASSETCAT',
        critvalue: a.assetcategory,
      });

      offerCriteriaList.push({ critcode: 'POWER', critvalue: a.power ?? '' });

      // additional attributes :
      a.entityAddAttributList?.forEach((e: any) => {
        offerCriteriaList.push({
          critcode: e.attcode,
          critvalue: e.attstringvalue ?? e.attnumericvalue,
        });
      });

      if (getEnvValue('FLAG_APPLY_ASSET_USE')) {
        a.assetusereqList?.forEach((u: any) => {
          assetUseCriteriaList.push({
            assetfamily: a.assetfamily,
            assettype: a.assettype,
            assetcategory: a.assetcategory,
            catalogid: a.catalogid ?? '',
            attcode: u.attcode ?? '',
            attvalue: u.usevalue ?? '',
          });
        });
      }
    });

    ret = {
      prcode: form?.getFieldValue('flagmasterfacility')
        ? form?.getFieldValue('mfprcode')
        : form?.getFieldValue('prcode') ?? '',
      tpid: form?.getFieldValue('client')?.tpid ?? 0,
      tpidbroker: form?.getFieldValue('broker')?.tpid ?? 0,
      tpidmanufacturer: assetList[0]?.tpidmanufacturer ?? 0,
      assetUseCriteria: assetUseCriteriaList,
      assetRVCriteria: [],
      offerCriteria: offerCriteriaList,
      flagApplyAssetUse: getEnvValue('FLAG_APPLY_ASSET_USE'),
      flagApplyAttributesExtendDurationValues: true,
      flagApplyAttributesExtendFirstRentalValues: true,
      flagApplyAttributesExtendRVValues: true,
      flagApplyAttributesExtendRateValues: true,
      flagApplyExtendDurationValues: true,
      flagApplyExtendFirstRentalValues: true,
      flagApplyExtendRVValues: true,
      flagApplyExtendRateValues: true,
    };
    return ret;
  };

  const updateElem = () => {
    const catlabel = form?.getFieldValue('ctecategory')?.label ?? 'Financial';
    const catvalue = form?.getFieldValue('ctecategory')?.value ?? 'FIN';

    const partamount = form?.getFieldValue('subsidy')
      ? form?.getFieldValue('subsidy')
      : 0;
    const partmethod = form?.getFieldValue('subsidy') ? 'REDUCEFIN' : 'NONE';

    let ofrid = form?.getFieldValue('pricing')?.ofrid ?? null;
    let ofrlabel = form?.getFieldValue('pricing')?.ofrlabel ?? null;
    let ofrtype = form?.getFieldValue('pricing')?.ofrtype ?? null;
    let priid = form?.getFieldValue('pricing')?.priid ?? null;

    if (form?.getFieldValue('pricing2')) {
      priid = form?.getFieldValue('pricing2')?.priid ?? null;
      ofrid = form?.getFieldValue('pricing2')?.ofrid ?? null;
      ofrlabel = form?.getFieldValue('pricing2')?.ofrlabel ?? null;
      ofrtype = form?.getFieldValue('pricing2')?.ofrtype ?? null;
    }

    const updatedobject = {
      ...finElement,
      priid: priid,
      // prilabel: form?.getFieldValue('pricing')?.prilabel ?? null,
      ofrid: ofrid,
      ofrlabel: ofrlabel,
      ofrtype: ofrtype,
      cteinvestamount: form?.getFieldValue('cteinvestamount'),
      ctefinancedamount: form?.getFieldValue('cteinvestamount'),
      ctecategory: catvalue,
      ctecategorylabel: catlabel,
      ctedescription: form?.getFieldValue('ctedescription') ?? '',
      ctepartamount: partamount,
      ctepartmethod: partmethod,
      calid: form?.getFieldValue('calid'),
      pricing: {
        priid: priid,
        // prilabel: form?.getFieldValue('pricing')?.prilabel ?? null,
        ofrid: ofrid,
        ofrlabel: ofrlabel,
        ofrtype: ofrtype,
      },
    };


    return updatedobject;
  };

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <Modal
        visible={visible}
        title={updateElement ? 'Update Element' : 'Add Element'}
        onCancel={() => {
          onClose();
        }}
        width="1000px"
        style={{ top: 20 }}
        footer={null}
        destroyOnClose
      >
        <Card>
          <Tabs
            type="card"
            tabBarExtraContent={
              display ? (
                <Row gutter={24}>
                  <Col span={updateElement ? 2 : 3} />
                  <Col span={3}></Col>
                  <Col span={7}>
                    <Button key="Cancel" onClick={onClose}>
                      Cancel
                    </Button>{' '}
                  </Col>
                  <Col span={4}>
                    <Button
                      key="Validate"
                      type="primary"
                      onClick={() => {
                        onSave(
                          updateElement ? updateElem() : addElement(),
                          form?.getFieldValue('pricing2') ??
                            form?.getFieldValue('pricing'),
                          updateElement ? 'update' : 'create'
                        );

                        onClose();
                      }}
                      icon={
                        updateElement ? (
                          <IUpdate color="white" height="16px" width="13px" />
                        ) : (
                          <IAdd
                            color="white"
                            width="14px"
                            height="14px"
                            svgstyle={{ marginTop: '3px' }}
                          />
                        )
                      }
                    >
                      {updateElement ? 'update' : 'add'}
                    </Button>
                  </Col>
                </Row>
              ) : null
            }
          >
            <TabPane key={1} tab={<GetLabel label="Quotation" />}>
              <br />

              {ctfclevel === 'MOASSMUEL' && (
                <FormInput
                  name="assetamount"
                  col
                  md={8}
                  labelCol={{ span: 24 }}
                >
                  <Value formatter={(val) => toCurrency(val)} />
                </FormInput>
              )}

              <Divider />
              <Row gutter={20}>
                <FormInput
                  name="ctecategory"
                  rules={[
                    {
                      required: true,
                      message: 'This field is mandatory',
                    },
                  ]}
                  col
                  md={8}
                  labelCol={{ span: 24 }}
                  shouldUpdate
                >
                  <ParListSelectWithLabelInValue
                    style={{ width: '100%' }}
                    parcode="CTEFIN"
                    onChange={(e) => {
                      if (e.value === 'ELEMASSET') {
                        const percentAmountAsset =
                          ctfclevel === 'MOASSMUEL'
                            ? ((assetAmount - totalFinAmountElemLinkedToAsset) /
                                assetAmount) *
                              100
                            : 0;
                        let max = assetAmount - totalFinAmountElemLinkedToAsset;

                        form?.setFieldsValue({
                          cteinvestamount: max >= 0 ? max : 0,
                          percentAmountAsset:
                            percentAmountAsset >= 0 ? percentAmountAsset : 0,
                        });
                      }
                      setCtecategory(e.value);
                    }}
                  />
                </FormInput>

                {ctecategory === 'ELEMASSET' && (
                  <FormInput
                    name="percentAmountAsset"
                    col
                    md={8}
                    labelCol={{ span: 24 }}
                    shouldUpdate
                  >
                    <InputRate
                      onChange={(e) => {
                        if (assetAmount) {
                          form?.setFieldValue(
                            'cteinvestamount',
                            (Number(e) / 100) * assetAmount
                          );
                        }
                      }}
                      max={
                        updateElement
                          ? (Number(finElement?.ctefinancedamount) /
                              assetAmount) *
                            100
                          : (maxInvestAmount / assetAmount) * 100
                      }
                    />
                  </FormInput>
                )}

                <FormInput
                  name="cteinvestamount"
                  rules={[
                    {
                      required: true,
                      message: 'This field is mandatory',
                    },
                  ]}
                  col
                  md={8}
                  labelCol={{ span: 24 }}
                  shouldUpdate
                >
                  <InputCurrency
                    currcode={localStorage.getItem('currcode') ?? ''}
                    max={
                      ctecategory === 'ELEMASSET' ? maxInvestAmount : undefined
                    }
                  />
                </FormInput>

                {ctecategory === 'ELEMLINK' && (
                  <FormInput
                    name="cteidparent"
                    col
                    md={12}
                    labelCol={{ span: 24 }}
                    shouldUpdate
                  >
                    <Select autoClearSearchValue {...props} allowClear>
                      {elements
                        ?.filter((el) => el.ctecategory === 'ELEMASSET')
                        .map((elem, index) => (
                          <Select.Option value={elem.cteid} key={index}>
                            {elem.ctedescription +
                              ' - ' +
                              toCurrency(
                                elem.ctefinancedamount,
                                localStorage.getItem('currcode')
                              )}
                          </Select.Option>
                        ))}
                    </Select>
                  </FormInput>
                )}
                <FormInput
                  col
                  md={12}
                  name="pricing"
                  labelCol={{ span: 24 }}
                  // hidden={getFieldValue('copyPricingwithSubsidy')}
                >
                  <PricingInput
                    style={{ width: '100%' }}
                    params={{
                      catalogid: 0,
                      duration: 0,
                      filters: '',
                      filtersList: getFilterList(),
                      finamount: form?.getFieldValue('cteinvestamount'),
                      mgid: 0,
                      offerid:
                        offerParams?.offerid ?? form?.getFieldValue('offerid'),
                      prcode: form?.getFieldValue('flagmasterfacility')
                        ? form?.getFieldValue('mfprcode')
                        : form?.getFieldValue('prcode')
                        ? form?.getFieldValue('prcode')
                        : '',
                    }}
                    onChange={(pricing) => {
                      form?.setFieldsValue({
                        ctedescription: pricing?.ofrdescription,
                        pricing: pricing,
                      });
                    }}
                    allowclear
                  />
                </FormInput>

                <FormInput
                  name="ctedirection"
                  col
                  md={8}
                  labelCol={{ span: 24 }}
                  shouldUpdate
                >
                  <ParListSelect style={{ width: '100%' }} parcode="CTEDIR" />
                </FormInput>

                <FormInput col md={8} name="calid">
                  <ParCalendarSelect calid={form?.getFieldValue('calid')} />
                </FormInput>

                {ctfclevel !== 'MOASSMUEL' && (
                  <FormInput
                    name="copyPricingwithSubsidy"
                    valuePropName="checked"
                    style={{ maxWidth: '50%' }}
                    labelCol={{ span: 24 }}
                    col
                    xs={8}
                  >
                    <Switch
                      checkedChildren={<CheckOutlined />}
                      unCheckedChildren={<CloseOutlined />}
                    />
                  </FormInput>
                )}
              </Row>
              <Row>
                {ctfclevel !== 'MOASSMUEL' && (
                  <Form.Item shouldUpdate noStyle>
                    {({ getFieldValue }) => {
                      return (
                        <>
                          <FormInput
                            col
                            xs={24}
                            name="elementToCopy"
                            valuePropName="checked"
                            style={{ maxWidth: '50%' }}
                            hidden={!getFieldValue('copyPricingwithSubsidy')}
                          >
                            <Select
                              style={{ width: '100%' }}
                              onChange={(e) => {
                                calculateSubsidy(e);
                              }}
                              allowClear
                            >
                              {form
                                ?.getFieldValue(['elements', 'FIN'])
                                .filter(
                                  (elem: any) =>
                                    elem.cteid !== finElement?.cteid
                                )
                                .map((element: any) => (
                                  <Select.Option
                                    value={element.cteid}
                                    key={element.cteid}
                                  >
                                    {element.ctedescription}
                                  </Select.Option>
                                ))}
                            </Select>
                          </FormInput>

                          <FormInput
                            col
                            xs={8}
                            name="oldinterest"
                            style={{ maxWidth: '50%' }}
                            hidden={!getFieldValue('copyPricingwithSubsidy')}
                          >
                            <InputCurrency
                              currcode={localStorage.getItem('currcode') ?? ''}
                            />
                          </FormInput>
                          <FormInput
                            col
                            xs={8}
                            name="newinterest"
                            style={{ maxWidth: '50%' }}
                            hidden={!getFieldValue('copyPricingwithSubsidy')}
                          >
                            <InputCurrency
                              currcode={localStorage.getItem('currcode') ?? ''}
                            />
                          </FormInput>
                          <Form.Item shouldUpdate noStyle>
                            <FormInput
                              col
                              xs={8}
                              name="subsidy"
                              style={{ maxWidth: '50%' }}
                              hidden={!getFieldValue('copyPricingwithSubsidy')}
                            >
                              <InputCurrency
                                currcode={
                                  localStorage.getItem('currcode') ?? ''
                                }
                              />
                            </FormInput>
                          </Form.Item>
                        </>
                      );
                    }}
                  </Form.Item>
                )}
              </Row>

              <Row>
                <FormInput
                  labelCol={{ span: 24 }}
                  col
                  md={24}
                  name="ctedescription"
                  rules={[{ required: true }]}
                >
                  <TextArea rows={4} />
                </FormInput>
              </Row>
              <br />
            </TabPane>
          </Tabs>
        </Card>
      </Modal>
    </div>
  );
};

export default SimpleFinElementModal;
